import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { Device, from } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useMedia } from 'react-use';
import S from './ProductDetails.styles';
const TableRow = (props) => {
    const isDesktop = useMedia(from(Device.Tablet), false);
    const [showContent, setShowContent] = React.useState(true);
    return (React.createElement(S.TableRow, { initial: isDesktop ? 'opened' : showContent ? 'opened' : 'closed', animate: isDesktop ? 'opened' : showContent ? 'opened' : 'closed' },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Title, { type: "button", "data-show": showContent, onClick: () => setShowContent(!showContent), "aria-label": !isDesktop
                    ? `${props.title} ${props.translations?.['global.accordion.toggle']}`
                    : undefined },
                props.title,
                " ",
                getSystemIcon(SystemIcon.ChevronDown))),
        React.createElement(S.ContentWrapper, { variants: {
                closed: {
                    height: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                },
                opened: {
                    visibility: 'visible',
                    height: 'auto',
                },
            } },
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }))));
};
const ProductDetails = (props) => {
    if (props.productDetails.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { translations: props.translations },
        React.createElement(S.Table, null, props.productDetails.map((row, index) => (React.createElement(TableRow, { key: index, title: row.title, content: row.content })))),
        props.link && (React.createElement(S.LinkArea, null,
            React.createElement(LinkButton, { buttonType: "tertiary", href: props.link?.url }, props.link?.text)))));
};
export default withMotionMax(ProductDetails);
